export const channel = {
  1: 'Presencial',
  2: 'Digital',
  3: 'Ambos'
};
